<template>
    <div class="px-3">
        <div class="row word-break">
            <div class="col-lg-6">
                <h4>รหัสมาสเตอร์ :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>masterId</h4>
            </div>
        </div>
        <div class="row word-break">
            <div class="col-lg-6">
                <h4>รหัสตัวแทน :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>dealerId</h4>
            </div>
        </div>
        <div class="row word-break">
            <div class="col-lg-6">
                <h4>รหัสร้านค้า :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>code</h4>
            </div>
        </div>
        <div class="row word-break">
            <div class="col-lg-6">
            <h4>แพ็กเกจ :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>package</h4>
            </div>
        </div>
        <div class="row word-break">
            <div class="col-lg-6">
            <h4>ประเภทการชำระเงิน :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <a class="a-tag color-tag h5" @click="openModalCondition()">
                    <u>CREDIT</u>
                </a>
            </div>
        </div>
        <ModalConditionWallet :condition="condition" />
    </div>
</template>
<script>
import { statusPayment } from "@/plugins/statusPayment.js"
import ModalConditionWallet from '@/components/Modals//ModalConditionWallet'

export default {
    name: "base-shop-details",
    data(){
        return {
            user : this.$USER_LOGIN.get(),
            statusPayment: statusPayment,
            condition:{
                show: false,
                type: null,
            }
        }
    },
    components:{ ModalConditionWallet },
    methods:{
        openModalCondition(){
            if(this.res.paymentType != 'CREDIT_SHIPPOP'){
                this.condition.show = true;
                this.condition.type = this.res.paymentType
            }
        },
        showShopDetails(){

            return {
                "dealerId": (
                    (
                        !this.user.isUnderByShippop ||
                        this.user.isSuperadmin
                    ) &&
                    !this.user.isShippop &&
                    !this.user.isMaster
                ),
                "shopCode": !this.user.isSuperadmin && !this.user.isMaster,
                "masterId": this.user.isMaster
            }
        }
    },
    computed: {
        res(){

            let logout = 'โปรดเข้าสู่ระบบใหม่'
            let res = {
                code : logout,
                package : logout,
                dealerId : logout,
                masterId : logout,
                paymentType : logout,
            }
            if( this.user ){
                res.code = this.user.details.shop_code
                res.package = this.user.details.shop_package
                res.dealerId = this.user.details.dealer_id
                res.masterId = this.user.details.master_id
                res.paymentType = this.user.details.payment_type
            }

            return res

        }
    }
}
</script>
<style scoped>
  .word-break {
    white-space: normal;
    word-break: break-word;
  }
  @media (min-width: 768px){
    .custom-text {
        text-align: right;
    }
}
</style>
